import{Icons as o}from"./icons/index.js";const n=({name:n})=>o[n];export{n as Svg};
